import { Brand, createBranded } from '@deltasierra/type-utilities';
import { ClientId } from '../client';
import { FullAuditable, HasId } from '../common';
import { Channel } from '../channel/Channel';

export interface Activity extends HasId<ActivityId>, FullAuditable {
    label: string;
    order: number;
    clientId: ClientId;
    channels?: Channel[];
}

export function sanitiseActivityLabel(label: string): string {
    return (label || '').trim();
}

export type ActivityId = Brand<number, 'ActivityId'>;
export const ActivityId = createBranded<ActivityId>();
